import { createSlice } from "@reduxjs/toolkit";

export const loaderStore = createSlice({
  name: "isLoader",
  initialState: {
    value: false,
  },
  reducers: {
    changeLoader: (state, val) => {
      state.value = val;
    },
  },
});

// Action creators are generated for each case reducer function
export const { changeLoader } = loaderStore.actions;

export default loaderStore.reducer;
